import apiFetch from '../apiFetch'

export default function (token, dossierId, lastAccessDate) {
  return apiFetch({ endPoint: `Campaign/anulateCampaign/${dossierId}`, method: 'PUT', token: token, lastAccessDate })
}
